import { Injectable } from '@angular/core';

import { filter, take } from 'rxjs/operators';

import { Cp2ApiService } from './cp2-api.service';
import { DataRepositoryService } from './datarepository.service';
import { AccessFacadeService } from './facades/access-facade.service';

@Injectable({
  providedIn: 'root',
})
export class LocatorService {
  constructor(
    private accessFacade: AccessFacadeService,
    private api: Cp2ApiService,
    private repo: DataRepositoryService,
  ) {}

  public get refetchLocators(): boolean {
    return localStorage.getItem('refetch-locators') === 'true';
  }

  public set refetchLocators(value: boolean) {
    localStorage.setItem('refetch-locators', value.toString());
  }

  public async initializeLocators(): Promise<void> {
    if (!this.refetchLocators) return;
    const device = await this.repo.getDevice();

    if (!device || !device.deviceId) {
      this.refetchLocators = false;
      return;
    }

    this.accessFacade.userTokens$
      .pipe(
        filter(e => !!e.token),
        take(1),
      )
      .subscribe(async t => {
        if (!t.token) return;

        await this.api.requestLocatorsResend(
          {
            device_uuid: device.deviceId,
            user_uuid: t.token.related_user_id,
          },
          t.token.access_token,
        );
        this.refetchLocators = false;
      });
  }
}
